<ng-container *ngIf="!isLoading else showLoadingPage">
  <ng-container *ngIf="(backToSolutionPage$ | async)
  || !(editModeConfig.isInEditMode && isModalOpened)
  && (displayProductLoaded$ | async)
">
    <div
      class="ds-grid"
      id="configureHeader"
      *ngIf="(displayProduct$ | async) as displayProduct"
    >
      <div class="row mb-8">
        <div
          *ngIf="commercialModelConfig.showConfiguratorHeadline"
          class="col-12 col-sm-8 col-md-6"
        >
          <div class="text-center">
            <p class="ds-heading--m udex-mb-24 udex-my-sm-24" data-cy="configurator-headline">
              {{ 'configurator.configureYourSolution' | cxTranslate }}
            </p>
          </div>
        </div>
        <div class="col-12 col-sm-2 col-md-3"></div>
      </div>
    </div>
  </ng-container>
  <div *ngIf="commercialModelConfig.showConfiguratorHeadline"
       class="w-100 separator mb-5"></div>
  <div
    class="udex-mt-20 udex-mb-24 udex-mb-sm-56 udex-mx-16 udex-mx-md-40 udex-mx-sm-24"
    [class.my-lg-5]="commercialModelConfig.showConfiguratorHeadline"
    *ngIf="(displayProductLoaded$ | async)
      && (displayProduct$ | async) as displayProduct"
  >
    <div class="row">
      <div class="d-flex align-content-center justify-content-end udex-mb-20">
        <div
          *ngIf="!modalMode && !forcedModal; else modalHeader"
          class="flex-grow-1 d-flex flex-column justify-content-center udex-my-0 udex-my-sm-20"
        >
          <h1 class="heading__regular--xs">{{ heading }}</h1>
        </div>

        <ng-template #modalHeader>
          <div class="flex-grow-1 d-flex flex-column justify-content-center">
            <h1 class="heading__medium--xs">{{ heading }}</h1>
          </div>
          <udex-control-button
            (click)="closeModal()"
            icon="decline"
            size="Large"
            [accessibleName]="'common.close' | cxTranslate"
            accessible-role="Button"
          ></udex-control-button>
        </ng-template>
      </div>

      <div class="col-md-8 col-12 udex-mb-40 info-messages-container">
        <udex-tile tabindex="0" libGroupSkip [groupSkipContent]="true" [interactive]="true" [href]="'javascript:void(0)'">
          <ng-container *ngFor="let message of infoMessages">
            <dcp-additional-information-message
              [notificationText]="message.message"
              [messageType]="message.type"
              [placeholders]="message.placeholders"
              [configuration]="configuratorModel"
              class="d-block mb-5"
            >
            </dcp-additional-information-message>
          </ng-container>
          <dcp-disposable-message [showActiveTemplate]="false"
                                  class="d-block udex-mb-24 udex-mb-xs-0"></dcp-disposable-message>
          <div
            class="body--s"
            data-cy="configurator-product"
          >
            <h2 class="cdk-visually-hidden content-wrapper__label">
              {{ 'configurator.licenseDetails' | cxTranslate }}
            </h2>
            <div class="content-wrapper">
              <div class="col-12 col-sm-3 col-md-4 col-lg-3 udex-me-lg-12 udex-me-md-0 udex-me-sm-12 udex-my-xs-12">
                <h3
                  *ngIf="transactionTypeTexts$ | async as transactionTypeTexts"
                  class="body--s text-nowrap"
                  data-cy="license-material-label"
                >
                  {{ transactionTypeTexts.licenseMaterial }}
                </h3>
              </div>

              <div class="text-grey col-12 col-sm-9 col-lg-9 udex-me-sm-12">
                <span data-cy="license-material-name">
                  {{ nameAndSupplierAlternativeAid }}
                </span>
              </div>
            </div>

            <ng-container
              *ngIf="commercialModelConfig.showDeploymentSystems && entitlements$ | async as entitlements">
              <div *ngIf="entitlements?.tenants?.length" class="content-wrapper udex-my-12">
                <div class="col-12 col-sm-3 col-md-4 col-lg-3 udex-me-lg-12 udex-me-md-0 udex-me-sm-12 udex-my-xs-12">
                  <h3
                    class="body--s"
                    data-cy="license-material-deployment"
                  >
                    {{ 'configurator.deploymentSystems.deployment' | cxTranslate }}
                  </h3>
                </div>

                <div class="col-12 col-sm-9 col-lg-9  udex-me-sm-12">
                  <dcp-deployment-systems
                    header="configurator.deploymentSystems.system"
                    description="configurator.deploymentSystems.description"
                    [tenantKeys]="tenantKeys"
                    [items]="entitlements.tenants"
                  ></dcp-deployment-systems>
                </div>
              </div>
            </ng-container>
          </div>
          <h2 class="cdk-visually-hidden">
            {{ 'configurator.yourConfiguration' | cxTranslate }}
          </h2>
          <form [formGroup]="configuratorForm" class="udex-mb-sm-24 udex-mb-xs-0">
            <formly-form data-cy="configurator-form"
                         [fields]="configuratorFields"
                         [form]="configuratorForm"
                         [model]="configuratorModel"
            >
            </formly-form>
          </form>
        </udex-tile>
      </div>
      <div
        class="col-md-4 col-12"
        *ngIf="
        (variantProductLoaded$ | async) &&
        (variantProduct$ | async) as variantProduct
      "
      >
        <h2 class="cdk-visually-hidden">
          {{ 'configurator.pricingSummary' | cxTranslate }}
        </h2>
        <dcp-price-display
          [priceData]="priceData"
          [renderedComponents]="renderedComponents"
          [product]="variantProduct"
          [transactionType]="transactionType"
          [isModalOpened]="isModalOpened"
        >
          <dcp-add-to-cart
            (addedToCart)="addedToCartInner()"
            (multiCurrencyCartError)="multiCurrencyCartAdded($event)"
            (isProcessing)="setProcessingState($event)"
            [isDisabled]="getProcessingState()"
            [btnTranslationKey]="editModeConfig.btnTranslationKey"
            [cartEntry]="cartEntry"
            [configuratorModel]="configuratorModel"
            [product]="variantProduct"
            [priceData]="priceData"
            [form]="configuratorForm"
            [cypressSelector]="editModeConfig.cypressSelector"
            [redirectToAfterAddToCart]="(editModeConfig.isInEditMode && isModalOpened) ? undefined : '/cart'"
            [isPrimary]="editModeConfig.isInEditMode"
          >
          </dcp-add-to-cart>
          <div [hidden]="editModeConfig.isInEditMode" class="udex-ms-12">
            <dcp-add-to-cart
              (addedToCart)="addedToCartInner()"
              (isProcessing)="setProcessingState($event)"
              [isDisabled]="getProcessingState()"
              [cartEntry]="cartEntry"
              [configuratorModel]="configuratorModel"
              (multiCurrencyCartError)="multiCurrencyCartAdded($event)"
              [product]="variantProduct"
              [priceData]="priceData"
              [form]="configuratorForm"
              btnTranslationKey="configurator.checkOut"
              cypressSelector="checkout-button"
              redirectToAfterAddToCart="/checkout"
              [shouldRedirectWithinIFrame]="true"
            >
            </dcp-add-to-cart>
          </div>
        </dcp-price-display>
      </div>
    </div>
  </div>
</ng-container>
<ng-template #showLoadingPage>
  <dcp-loading-page/>
</ng-template>
